import { Table, AutoSizer, InfiniteLoader, Column } from 'react-virtualized';
import styles from './Table.module.scss';

const InfiniteTable = ({ list, lazyload, ...props }) => {
  function isRowLoaded({ index }) {
    return !!list[index];
  }
  return (
    <InfiniteLoader isRowLoaded={isRowLoaded} loadMoreRows={lazyload} rowCount={list.length}>
      {({ onRowsRendered, registerChild }) => (
        <AutoSizer>
          {({ width, height }) => (
            <Table
              onRowsRendered={onRowsRendered}
              ref={registerChild}
              headerClassName={styles.headerColumn}
              height={height}
              rowGetter={({ index }) => list[index]}
              rowCount={list.length}
              width={width}
               
              {...props}
            >
              <Column label="Header Label" dataKey="name" disableSort width={90} />
              <Column
                width={210}
                disableSort
                label="The description label is really long so that it will be truncated"
                dataKey="random"
                className={styles.exampleColumn}
                cellRenderer={({ cellData }) => cellData}
                flexGrow={1}
              />
            </Table>
          )}
        </AutoSizer>
      )}
    </InfiniteLoader>
  );
};

InfiniteTable.defaultProps = {
  disableHeader: false,
  headerHeight: 64,
  lazyload: () => {},
};

export default InfiniteTable;
